var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-res-not-found"},[_c('div',{staticClass:"nostr-img-cls"},[_c('img',{attrs:{"src":require("@/assets/images/no_store.png")}}),_c('div',{staticClass:"no-txt-fnd"},[_vm._v(" We are currently not serviceable in your area\" ")]),_c('span',[_vm._v("You can pick your order up from nearest restaurant in the pickup section")])])])
}]

export { render, staticRenderFns }